import PrestationFormController from './prestation.form.controller';

export default {
    template: require('./prestation.form.html'),
    controller: PrestationFormController
};
